import CycleTimeMonitoring from './cycleTimeMonitoring/PluginSetup'
import EventsTable from './eventsTable/PluginSetup'
import FactoryCycleTimeMonitoring from './factoryCycleTimeMonitoring/PluginSetup'
import FgEventsTable from './fgEventsTable/PluginSetup'
import LineLiveStatusSetup from './lineLiveStatus/PluginSetup'
import LineStageGanttChartSetup from './lineStageGanttChart/PluginSetup'
import HeadCount from './headCount/PluginSetup'
import PlyLayerShopFloor from './plyLayer/PluginSetup'

const install = ( molten ) => {
  LineLiveStatusSetup.install( molten )
  LineStageGanttChartSetup.install( molten )
  CycleTimeMonitoring.install( molten )
  FactoryCycleTimeMonitoring.install( molten )
  EventsTable.install( molten )
  FgEventsTable.install( molten )
  HeadCount.install( molten )
  PlyLayerShopFloor.install( molten )
}

export default { install }
